import {
  FormOutlined,
  GlobalOutlined,
  OpenAIOutlined,
  FileTextOutlined,
  FolderOutlined,
  UserOutlined,
  AppstoreOutlined,
  WalletOutlined,
  CalculatorOutlined,
  PercentageOutlined,
  SwapOutlined,
  GoldOutlined,
  HomeOutlined,
  BuildOutlined,
  FileDoneOutlined,
  DollarOutlined,
  BankOutlined,
  SolutionOutlined,
  CheckCircleOutlined,
  FileProtectOutlined,
  FileSearchOutlined,
  ThunderboltOutlined,
  EyeOutlined,
} from '@ant-design/icons';
import { Building2, Eye } from 'lucide-react';

export const ICON_MAPPER: { [key: string]: JSX.Element } = {
  search: <OpenAIOutlined />,
  zoom: <GlobalOutlined />,
  document: <FileTextOutlined />,
  form: <FormOutlined />,
  folder: <FolderOutlined />,
  user: <UserOutlined />,
  dashboard: <AppstoreOutlined />,
  wallet: <WalletOutlined />,
  calc: <CalculatorOutlined />,
  percent: <PercentageOutlined />,
  swap: <SwapOutlined />,
  utils: <GoldOutlined />,
  home: <HomeOutlined />,
  building: <BuildOutlined />,
  // Additional mappings for menu items
  mortgage: <BankOutlined />,
  purchase: <DollarOutlined />,
  refinance: <SolutionOutlined />,
  preapproval: <FileDoneOutlined />,
  settled: <CheckCircleOutlined />,
  tax: <PercentageOutlined />,
  'lodge-return': <FileProtectOutlined />,
  'tax-advice': <FileSearchOutlined />,
  'health-check': <CheckCircleOutlined />,
  'tax-deal-stage': <ThunderboltOutlined />,
  fx: <SwapOutlined />,
  ofx: <BankOutlined />,
  torfx: <DollarOutlined />,
  profile: <UserOutlined />,
  conveyancing: <BuildOutlined />,
  watchlist: <EyeOutlined />,
};
